import { SkeletonElement } from '../../../../common';
import { css } from '@bts-web/utils-style-engine';

export const PortfolioAreaChartSkeleton = () => (
  <div
    className={css({
      borderBottom: '4px solid',
      borderBottomColor: 'neutrals.widget_primary',
    })}
    data-testid="portfolio-area-chart-skeleton"
  >
    <div className={css({ hideFrom: 'lg' })}>
      <SkeletonElement height="325px" width="100%" />
    </div>

    <div className={css({ hideBelow: 'lg' })}>
      <SkeletonElement height="478px" width="100%" />
    </div>
  </div>
);
